import React from 'react'
import type { StartLabelCheckboxSelectFieldProps } from '@edge/spark/feature-mui-rhf-inputs'
import { StartLabelCheckboxSelectField } from '@edge/spark/feature-mui-rhf-inputs'

export const CheckboxSelectField: React.VFC<StartLabelCheckboxSelectFieldProps> = (
    props: StartLabelCheckboxSelectFieldProps,
) => {
    return (
        <StartLabelCheckboxSelectField
            fullWidth
            InputLabelProps={{ shrink: true }}
            // SelectProps={{ displayEmpty: true }}
            variant="standard"
            {...props}
        />
    )
}
